
  export function videoControls(parent) {

    const player = parent.current;
    const body = document.querySelector("body");

    let video = player.querySelector("video");
    // check for video element, return if not found
    if (typeof video == "undefined" || video == null) {
      return;
    }
    
    let controls = player.querySelector(".controls");
    //let largeBtn = player.querySelector(".playBtn");
    let playpauseBtn = player.querySelector(".playpause");
    let muteBtn = player.querySelector(".mute");
    let volumeSlider = player.querySelector("#volume-bar");
    let volumeBg = player.querySelector(".volume .bg");
    let seekSlider = player.querySelector("#seek-bar");
    let seekBg = player.querySelector(".scrubber .bg");
    let fullBtn = player.querySelector(".gofull");
    let closeBtn = player.querySelector(".close-icon");
    let timestampEl = player.querySelector(".timestamp");
    let durationEl = player.querySelector(".timestamp .duration");
    let progressEl = player.querySelector(".timestamp .progress");

    // ✨ Cleanup first
    video.removeEventListener("playing", videoPlaying);
    video.removeEventListener("pause", videoPaused);
    video.removeEventListener("timeupdate", videoTimeUpdate);
    video.removeEventListener("ended", videoEnded);
    video.removeEventListener("click", playPause);
    playpauseBtn.removeEventListener("click", playPause);
    muteBtn.removeEventListener("click", volumeToggle);
    seekSlider.removeEventListener("input", videoSeek);
    volumeSlider.removeEventListener("input", volumeChange);
    fullBtn.removeEventListener("click", goFullView);

    // event listeners
    //video.addEventListener("canplay", videoCanPlay);
    video.addEventListener("playing", videoPlaying);
    video.addEventListener("pause", videoPaused);
    video.addEventListener("timeupdate", videoTimeUpdate);
    video.addEventListener("ended", videoEnded);
    //largeBtn.addEventListener("click", playPause);
    video.addEventListener("click", playPause);
    playpauseBtn.addEventListener("click", playPause);
    muteBtn.addEventListener("click", volumeToggle);
    seekSlider.addEventListener("input", videoSeek);
    volumeSlider.addEventListener("input", volumeChange);
    fullBtn.addEventListener("click", goFullView);
    //closeBtn.addEventListener("click", closeFullView);
    // keyboard events
    body.addEventListener("keydown", (event) => {
      // toggle play / pause of video with spacebar
      // esc key closes lightbox
      if (event.keyCode === 27 && body.classList.contains("full")) {
        event.preventDefault();
        body.classList.remove("full");
      }
    });
    // show / hide controls based on mousemovement over video
    var mousetimeout;
    player.onmousemove = function () {
      clearTimeout(mousetimeout);
      controls.classList.remove("hide");
      mousetimeout = setTimeout(function () {
        // hide video controls if no mouse movement after 2 seconds
        controls.classList.add("hide");
      }, 2000);
    };
    player.onmouseleave = function () {
      controls.classList.add("hide");
    };
    // hide controls after 2 seconds is no user action is taken
    setTimeout(function () {
      controls.classList.add("hide");
    }, 2000);
    // functions
    function playPause() {
      console.log("playPause");
      if (!video.paused && !video.ended) {
        video.pause();
      } else {
        video.play();
      }
    }
    function toggleFullScreen() {
      if (
        !document.fullscreenElement &&
        !document.mozFullScreen &&
        !document.webkitIsFullScreen &&
        !document.msFullscreenElement
      ) {
        if (player.requestFullscreen) {
          player.requestFullscreen();
        } else if (player.mozRequestFullScreen) {
          player.mozRequestFullScreen();
        } else if (player.webkitRequestFullscreen) {
          player.webkitRequestFullscreen();
        } else if (player.msRequestFullscreen) {
          player.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    }
    function videoEnded() {
      video.currentTime = 0;
    }
    function videoCanPlay() {
      var vid_duration = video.duration;
      let vid_minutes = 0;
      let vid_seconds = 0;
      vid_minutes = parseInt(vid_duration / 60);
      if (vid_minutes < 10) {
        vid_minutes = `${vid_minutes}`;
      }
      vid_seconds = parseInt(vid_duration) - vid_minutes * 60;
      if (vid_seconds < 10) {
        vid_seconds = `0${vid_seconds}`;
      }
      var vid_dur_output = `${vid_minutes}:${vid_seconds}`;
      durationEl.innerHTML = vid_dur_output;
    }
    function videoPlaying() {
      body.classList.add("hide_mark");
      player.classList.add("playing");
      player.classList.remove("ended");
      player.classList.remove("paused");
      timestampEl.classList.add("show");
    }
    function videoPaused() {
      player.classList.remove("playing");
      player.classList.add("paused");
      body.classList.remove("hide_mark");
    }
    function videoTimeUpdate() {
      let rawTime = video.currentTime;
      let minutes = 0;
      let seconds = 0;
      minutes = parseInt(rawTime / 60);
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      seconds = parseInt(rawTime) - minutes * 60;
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      let output = `${minutes}:${seconds}`;
      progressEl.innerHTML = output;
      // Calculate the slider value
      var value = (100 / video.duration) * video.currentTime;
      // transition the timestamp el by animation left value
      timestampEl.style.left = value + "%";
      // Update the slider value and bg value
      seekSlider.value = value;
      seekBg.style.width = value + "%";
    }
    function videoSeek() {
      // Calculate the new time
      var time = video.duration * (seekSlider.value / 100);
      // Update the video time
      video.currentTime = time;
    }
    function volumeToggle() {
      if (video.muted == false) {
        video.muted = true;
        player.classList.add("muted");
      } else {
        video.muted = false;
        player.classList.remove("muted");
      }
    }
    function volumeChange() {
      video.volume = volumeSlider.value;
      volumeBg.style.width = volumeSlider.value * 100 + "%";
    }
    function goFullView() {
      toggleFullScreen();
    }
    function closeFullView() {
      body.classList.remove("full");
    }
  }